import { get } from 'lodash'
import React, { useContext } from 'react'
import { Container } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import styled from 'styled-components'

import Alert from '../../Alert'
import Button from '../../Button'
import GlobalUserSelect from '../../GlobalUserSelect'
import GlobalUserWindow from '../../GlobalUserWindow'
import LanguageSelect from '../../LanguageSelect'
import StatusPanel from '../../StatusPanel'
import ThemeContext from '../../ThemeContext'
import TwoFactorAuth from '../../TwoFactorAuth'
import Item from './Item'

const Wrapper = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  border: 0px solid red;
  height: 60px;
`

const MenuLeft = styled.div``

const MenuRight = styled.div`
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  align-self: stretch;
`

const SelectWrapper = styled.div`
  align-items: center;
  padding: 0 10px;
`

const Logo = (props) => {
  return (
    <div className="mx-2">
      <img src={props.url} style={{ height: '40px' }} />
    </div>
  )
}

const Toggle = styled.div`
  font-size: 1.5em;
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  color: ${({ color }) => color || ''};

  @media (min-width: 767px) {
    display: none;
  }
`

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 10px;
`

const Header = (props) => {
  const {
    onToggle,
    isToggled,
    logo,
    text,
    subtext,
    isStaging,
    coloredHeader,
    rightItems = [],
    centerItems = [],
    fluid,
    showLanguageSelect,
    useDarkMode = false,
    showGlobalUserSelect,
    showManual,
    enableAdminWarningMode,
    twoFaEnabled,
    twoFaForced,
    globalItem = {},
  } = props

  const navigateHome = () => {
    window.location.href = '/'
  }

  const theme = useContext(ThemeContext)

  return (
    <Wrapper backgroundColor={coloredHeader ? theme.backgroundColor : ''}>
      <Container as={HeaderContainer} fluid={fluid}>
        <MenuLeft>
          <div
            style={{ display: 'flex', cursor: 'pointer', alignItems: 'center' }}
            onClick={navigateHome}
          >
            <Logo url={logo} />
            {text && (
              <div>
                <div
                  style={{
                    margin: '0',
                    textTransform: 'uppercase',
                    fontSize: '17px',
                    fontWeight: 'normal',
                    color: theme.headerTextColor,
                  }}
                  className="align-self-center"
                >
                  {text}
                  {false && subtext && (
                    <div className="text-muted" style={{ fontSize: '0.75em' }}>
                      {subtext}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </MenuLeft>
        <MenuRight>
          {enableAdminWarningMode && (
            <div className="mt-4">
              <Alert danger>ADMIN ACCOUNT</Alert>
            </div>
          )}
          {centerItems && <MediaQuery minWidth={767}>{centerItems}</MediaQuery>}
          {props.showGlobalWindow && isStaging && (
            <GlobalUserWindow item={globalItem} />
          )}
          {twoFaEnabled && (
            <TwoFactorAuth
              buttonElement={<Button textOnly icon="fas fa-lock" />}
              strictMode={twoFaForced}
            />
          )}
          {showManual && (
            <Button
              textOnly
              href="https://docs.1st-scan.net/"
              target="_blank"
              icon="fas fa-book"
            />
          )}
          {get(props.statusPanelConfig, 'show') && (
            <StatusPanel url={get(props.statusPanelConfig, 'url')} />
          )}
          {showLanguageSelect && (
            <MediaQuery minWidth={767}>
              <SelectWrapper>
                <LanguageSelect
                  useDarkMode={useDarkMode}
                  hideCountryText
                  useMinWidth
                />
              </SelectWrapper>
            </MediaQuery>
          )}

          {showGlobalUserSelect && (
            <MediaQuery minWidth={767}>
              <SelectWrapper>
                <GlobalUserSelect useDarkMode={useDarkMode} />
              </SelectWrapper>
            </MediaQuery>
          )}
          {rightItems
            .filter(Boolean)
            .filter((item) => item.show !== false)
            .map((item, index) => (
              <Item key={index} {...item} color={theme.headerTextColor} />
            ))}
          <Toggle onClick={onToggle} color={theme.headerTextColor}>
            {isToggled ? (
              <i className="fal fa-times" />
            ) : (
              <i className="far fa-bars" />
            )}
          </Toggle>
        </MenuRight>
      </Container>
    </Wrapper>
  )
}

export default Header
